// extracted by mini-css-extract-plugin
export default {"Modal":"modal_Modal__FzlxE","Modal_Header":"modal_Modal_Header__3sJJT","Modal_body":"modal_Modal_body__c-ZRi"};